// extracted by mini-css-extract-plugin
module.exports = {"subtotal-loader":"fbt-subtotal-action_subtotal-loader__wCAc8","price":"fbt-subtotal-action_price__abVry"};